const netzero = [
  {
    title: '台灣企業要當先行者，立即探索循環經濟新契機',
    date: '2022/09/28',
    url: 'https://ieknet.iek.org.tw/ExtAuth/More_ExtAuth.aspx?indu_idno=18&domain=94&ea_id=347138258'
  },
  {
    title: '以終為始，推動台灣邁向「2050淨零排放」',
    date: '2022/09/21',
    url: 'https://ieknet.iek.org.tw/ExtAuth/More_ExtAuth.aspx?indu_idno=18&domain=94&ea_id=346741689'
  },
  {
    title: '資源循環的減碳作法',
    date: '2022/09/19',
    url: 'https://ieknet.iek.org.tw/ExtAuth/More_ExtAuth.aspx?indu_idno=18&domain=94&ea_id=581830036'
  },
  {
    title: '工業部門如何運用資源循環來減碳？',
    date: '2022/09/19',
    url: 'https://ieknet.iek.org.tw/ExtAuth/More_ExtAuth.aspx?indu_idno=18&domain=94&ea_id=582576548'
  },
  {
    title: '農業部門如何運用資源循環來減碳？',
    date: '2022/09/19',
    url: 'https://ieknet.iek.org.tw/ExtAuth/More_ExtAuth.aspx?indu_idno=18&domain=94&ea_id=582851327'
  },
  {
    title: '循環經濟是實踐淨零排放的重要解方',
    date: '2022/09/19',
    url: 'https://ieknet.iek.org.tw/ExtAuth/More_ExtAuth.aspx?indu_idno=18&domain=94&ea_id=584940968'
  },
  {
    title: '國際趨勢：資源循環對淨零排放有決定性的貢獻',
    date: '2022/09/18',
    url: 'https://ieknet.iek.org.tw/ExtAuth/More_ExtAuth.aspx?indu_idno=18&domain=94&ea_id=352351421'
  },
  {
    title: '掌握數位科技大趨勢 眺望淨零永續新生態',
    date: '2022/06/18',
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_more.aspx?actiontype=ppt&indu_idno=0&domain=82&sld_preid=6769'
  },
  {
    title: '淨零碳排數位產業地圖',
    date: '綠色貿易資訊',
    url: 'https://www.greentrade.org.tw/zh-hant/content/%E6%95%B8%E4%BD%8D%E7%94%A2%E6%A5%AD%E5%9C%B0%E5%9C%96%E7%B8%BD%E8%BF%B0'
  },
  {
    title: '國際關鍵議題基盤資訊~氫能',
    date: '2022/06/16',
    url: 'https://ieknet.iek.org.tw/member/login.aspx'
  },
  {
    title: '國際關鍵議題基盤資訊~電動車',
    date: '2022/06/16',
    url: 'https://ieknet.iek.org.tw/member/login.aspx'
  },
  {
    title: '工研院IEKCQM：2022年製造業產值預估延續成長6.04%',
    date: '2022/06/10',
    url: 'https://ieknet.iek.org.tw/iekrpt/rpt_open.aspx?actiontype=rpt&indu_idno=0&domain=2&rpt_idno=178782840'
  },
  {
    title: '臺灣企業因應國際品牌供應鏈減碳要求之機制建立與綠色商機',
    date: '2022/05/25',
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_more.aspx?actiontype=ppt&indu_idno=0&domain=78&sld_preid=6733'
  },
  {
    title: '從COP26看企業如何因應2050淨零碳排',
    date: '綠色貿易資訊',
    url: 'https://www.greentrade.org.tw/zh-hant/publication/435'
  },
  {
    title: '臺灣2050淨零排放路徑及策略總說明-摘要',
    date: '綠色貿易資訊',
    url: 'https://www.greentrade.org.tw/zh-hant/publication/435'
  },
  {
    title: '歐美日各國能源關連政策',
    date: '2022/04/08',
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_more.aspx?actiontype=ppt&indu_idno=5&domain=90&sld_preid=6695'
  },
  {
    title: '循環經濟跨域合作機制',
    date: '2022/02/23',
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_more.aspx?actiontype=ppt&indu_idno=5&domain=90&sld_preid=6645'
  },
  {
    title: '解析CES 2022 從數位賦能應用看永續未來商機',
    date: '2022/02/21',
    url: 'https://ieknet.iek.org.tw/iekrpt/rpt_open.aspx?actiontype=rpt&indu_idno=0&domain=42&rpt_idno=426187328'
  },
  {
    title: '循環經濟 締造新興工作機會',
    date: '2022/01/11',
    url: 'https://ieknet.iek.org.tw/iekrpt/rpt_open.aspx?actiontype=rpt&indu_idno=0&domain=70&rpt_idno=877021741'
  },
  // {
  //   title: '淨零碳排 全球能源市場典範轉移',
  //   date: '2022/01/06',
  //   url: 'https://ieknet.iek.org.tw/iekrpt/rpt_open.aspx?actiontype=rpt&indu_idno=0&domain=28&rpt_idno=447051881'
  // },
  // {
  //   title: 'ESG永續發展下之產業趨勢',
  //   date: '2021/12/29',
  //   url: 'https://ieknet.iek.org.tw/iekppt/ppt_more.aspx?actiontype=ppt&indu_idno=0&domain=28&sld_preid=6636'
  // },
  // {
  //   title: '全球淨零碳排趨勢下之再生能源產業新格局',
  //   date: '2021/12/22',
  //   url: 'https://ieknet.iek.org.tw/iekppt/ppt_more.aspx?actiontype=ppt&indu_idno=5&domain=90&sld_preid=6604'
  // },
  // {
  //   title: '氫能發展趨勢與臺灣未來方向',
  //   date: '2021/12/22',
  //   url: 'https://ieknet.iek.org.tw/iekppt/ppt_more.aspx?actiontype=ppt&indu_idno=0&domain=28&sld_preid=6607'
  // },
  // {
  //   title: '淨零碳排趨勢下，台灣在化合物半導體產業發展機會',
  //   date: '2021/12/21',
  //   url: 'https://ieknet.iek.org.tw/iekppt/ppt_more.aspx?actiontype=ppt&indu_idno=0&domain=10&sld_preid=6589'
  // },
  {
    title: '國際淨零碳排趨勢與臺灣綠色貿易商機調查報告',
    date: '綠色貿易資訊',
    url: 'https://www.greentrade.org.tw/zh-hant/publication/435'
  },
  {
    title: '國際鏈結之企業碳足跡指引',
    date: '綠色貿易資訊',
    url: 'https://www.greentrade.org.tw/zh-hant/publication/435'
  },
]

export default netzero;